<template>
  <div>
  <!-- <p>sss</p> -->
    <CHeader fixed with-subheader light  :style="{'background-color': loggedInUser.header_color ? loggedInUser.header_color : 'whitesmoke', 'height': '110px !important' }">
      <img :src="loggedInUser.logoUrl" alt="..." class="main_logo" style="width: 160px">
      <CToggler
        in-header
        class="ml-3 d-lg-none d-lg-none"
        @click="$store.commit('toggleSidebarMobile')"        
      />
      <CToggler
        in-header
        class="ml-3 d-md-down-none d-lg-none"
        @click="$store.commit('toggleSidebarDesktop')"
      />
  <!--      <CDropdown-->
  <!--              color=""-->
  <!--              toggler-text="Dropdown Button"-->
  <!--              class="m-2 multi-language"-->
  <!--      >-->
  <!--          <template #toggler>-->
  <!--              <CHeaderNavLink>-->
  <!--                  <div class="c-avatar">-->
  <!--                      <country-flag country='gb' size='small'/>-->
  <!--                  </div>-->
  <!--              </CHeaderNavLink>-->
  <!--          </template>-->
  <!--          <CDropdownItem><a><country-flag country='gb' size='small'/>English - UK</a></CDropdownItem>-->
  <!--          <CDropdownItem><a href="#"><country-flag country='it' size='small'/>Italian - IT</a></CDropdownItem>-->
  <!--          <CDropdownItem><a><country-flag country='br' size='small'/>Portuguese - BR</a></CDropdownItem>-->
  <!--      </CDropdown>-->
  
      <CHeaderBrand class="mx-auto d-lg-none" to="/" style="height: 50px !important;">
  <!--      <CIcon name="logo" height="48" alt="Logo"/>-->
        <!-- <p style="font-size: 25px;">SOSPESO</p> -->
        <img :src="loggedInUser.logoUrl" alt="..." class="img-thumbnail logo-image" style = "border:none; width: 160px; background: none;">
      </CHeaderBrand>
      <CHeaderNav class="d-md-down-none mr-auto">
  <!--      <CHeaderNavItem class="px-3">-->
  <!--        <CHeaderNavLink to="/dashboard">-->
  <!--          Dashboard-->
  <!--        </CHeaderNavLink>-->
  <!--      </CHeaderNavItem>-->
  <!--      <CHeaderNavItem class="px-3">-->
  <!--        <CHeaderNavLink to="/users" exact>-->
  <!--          Users-->
  <!--        </CHeaderNavLink>-->
  <!--      </CHeaderNavItem>-->
  <!--      <CHeaderNavItem class="px-3">-->
  <!--        <CHeaderNavLink>-->
  <!--          Settings-->
  <!--        </CHeaderNavLink>-->
  <!--      </CHeaderNavItem>-->
      </CHeaderNav>
      <CHeaderNav class="dropdown_notify_zoom mr-4 cheader_nav1" style="margin-top: 6px;">
        <TheHeaderDropdownNotification />
      </CHeaderNav>
      <!-- <CHeaderNav class="mr-4">
        <a :href="`#/user_tip_stat/${loggedInUser._id}`">
          <strong>{{loggedInUser.alias}}</strong>
        </a>
      </CHeaderNav> -->
  
      <CHeaderNav class="dropdown_accnt_zoom mr-4 " style="margin-top: 5px;">
  <!--      <CHeaderNavItem class="d-md-down-none mx-2">-->
  <!--        <CHeaderNavLink>-->
  <!--          <CIcon name="cil-bell"/>-->
  <!--        </CHeaderNavLink>-->
  <!--      </CHeaderNavItem>-->
  <!--      <CHeaderNavItem class="d-md-down-none mx-2">-->
  <!--        <CHeaderNavLink>-->
  <!--          <CIcon name="cil-list"/>-->
  <!--        </CHeaderNavLink>-->
  <!--      </CHeaderNavItem>-->
  <!--      <CHeaderNavItem class="d-md-down-none mx-2">-->
  <!--        <CHeaderNavLink>-->
  <!--          <CIcon name="cil-envelope-open"/>-->
  <!--        </CHeaderNavLink>-->
  <!--      </CHeaderNavItem>-->
        <TheHeaderDropdownAccnt/>
      </CHeaderNav>
      <CSubheader class="px-3" :style="{'background-color': loggedInUser.sub_header_color ? loggedInUser.sub_header_color : 'white', 'height': '50px !important' }">
        <CBreadcrumbRouter :style="{'background-color': loggedInUser.sub_header_color ? loggedInUser.sub_header_color : 'white' }" class="border-0 mb-0 bread_crumb"/>

        <div style="margin: auto; margin-right: 5px; cursor: pointer; color: blue;" >          
          <!-- <span @click="goToPage('UserSetting')">GMT{{timezone}}</span> -->
          <span style="padding-left: 10px;" @click="goToPage('UserSetting')">{{curTime}}</span>          
          <span style="padding-left: 10px; color: blue;" @click="goToPage('UserSetting')">{{lang_label}}</span>
        </div>
        <span style="margin-top: 5px; cursor: pointer;" @click="goToPage('UserSetting')"><country-flag :country="lang" style="" size="normal"/></span>
      </CSubheader>

    </CHeader>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  
  import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt';
  import TheHeaderDropdownNotification from './TheHeaderDropdownNotification';
  import CBreadcrumbRouter from './CBreadcrumbRouter';
  import {convertUTCToLocal, defaultFormat, defaultHM} from '@/helpers/time';
  
  
  export default {
    name: 'TheHeader',
    data () {
      return { 
          lang: 'en',
          timezone: 0,
          curTime: null,
          lang_label: 'en',
          timezone_map: {
            '0': '+00',
            '+1': '+01',
            '+2': '+02',
            '+3': '+03',
            '+4': '+04',
            '+5': '+05',
            '+6': '+06',
            '+7': '+07',
            '+8': '+08',
            '+9': '+09',
            '-1': '-01',
            '-2': '-02',
            '-3': '-03',
            '-4': '-04',
            '-5': '-05',
            '-6': '-06',
            '-7': '-07',
            '-8': '-08',
            '-9': '-09',
            
          },
          totalFeeds: 0
      }
    },
    components: {
      TheHeaderDropdownAccnt,
      TheHeaderDropdownNotification,
      CBreadcrumbRouter,
      
    },
    computed: {
      ...mapGetters(['loggedInUser']),
    },
    methods: {
      ...mapActions(['sendUserId']),
      ...mapActions('notifications', ['getNotificationInfo']),
      
      updatNotification() {
        this.getNotificationInfo().then(data => {})
        .catch(err => {
          console.log(err);
        });
      },
      setFlag() {
        var userInfo = localStorage.getItem('userInfo');
        userInfo = JSON.parse(userInfo)
        
        this.timezone = localStorage.getItem('mytimezone');


        if (this.timezone > 0)
          this.timezone = '+' + this.timezone

        this.timezone = this.timezone_map[this.timezone];
        this.lang = localStorage.getItem('lang');
        this.lang_label = localStorage.getItem('lang');
        if (this.lang == 'en') {
          this.lang_label = 'en'
          this.lang = 'gb'
        }
      },
      setTime() {
        var utctime = new Date().toISOString()
        let curTime = convertUTCToLocal(utctime, (new Date()).getTimezoneOffset() / 60);
        curTime = defaultHM(curTime).toString();
        console.log(curTime);

        this.curTime = curTime;
      },
      goToPage(page, params = {}) {
        this.$router.push({
          name: page,
          params
        })
      },
      send_userId() {
          let token = localStorage.getItem('token');
          if (!token)
            clearInterval(this.sendIdInterval);
          
          if (token && this.loggedInUser && this.loggedInUser.user_id !== null) {
            console.log('======== sending id ')
            console.log(this.loggedInUser.user_id)
            this.sendUserId({userId: parseInt(this.loggedInUser.user_id)}).then(data => {
              
            })
            .catch(err => {
              
            });
          }
       }
    },
    mounted() {
      this.sockets.subscribe('newNotifications', (data) => {
        this.updatNotification();
      // setInterval(this.getNotificationInfo, 30000);
      });

      setTimeout(() => {  
          setInterval(this.send_userId, 15 * 1000);
       }, 15000);
      

    },
    created() {
      this.updatNotification();
      this.setFlag();
      this.setTime();
      this.interval = setInterval(() => this.setTime(), 30000);
      this.sendIdInterval = setInterval(this.send_userId, 10 * 1000);
    },
    beforeDestroy() {
      clearInterval(this.sendIdInterval);
    },
    watch: {
      loggedInUser: {
        deep: true,
        immediate: true,
        handler(val) {
          if(this.loggedInUser)
            this.$socket.emit('new-user', this.loggedInUser);
        }
      },
     
      

    }
  }
  </script>
  <style>
    .bread_crumb{
      padding-top: 12px !important;
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
      .multi-language{
          float: right;
      }
      .main_logo{
        /*zoom: 25%;*/
        margin-left: 10px;
        /*-moz-transform:  scale(0.25,0.25);
        -moz-transform-origin: left top;*/
        -moz-margin-start: 5px;
      }
  
      @media screen and (max-width: 991px) {
    .main_logo {
      display: none;
    }
    .cheader_nav1{
      margin-top: 6px !important;
    }
  }
  </style>
  